import React, { FC } from 'react';
import styled from 'styled-components';
import { Colors } from '../../../styles/colors';
import { Label } from './Label';

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: 2rem;
`;

export const ToggleWrapper = styled.div`
  position: relative;
  height: 2rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

export const StyledCheckbox = styled.input`
  appearance: none;
  width: 5rem;
  height: 2rem;
  display: inline-block;
  position: relative;
  border-radius: 1rem;
  overflow: hidden;
  outline: none;
  border: none;
  cursor: pointer;
  background-color: ${Colors.gray};
  transition: background-color ease 0.5s;
  
  &:before {
    content: "Ja Nein";
    display: block;
    position: absolute;
    z-index: 2;
    width: 1.75rem;
    height: 1.75rem;
    border-radius: 50%;
    background: #fff;
    top: 0.125rem;
    left: 0.125rem;
    white-space: nowrap;
    text-indent: -1.7rem;
    word-spacing: 2.75rem;
    line-height: 1.75rem;
    color: #fff;
    text-shadow: -0.063rem 0.063rem rgba(0,0,0,0.15);
    box-shadow: 0 0.063rem 0.125rem rgba(0,0,0,0.2);
    transition: all cubic-bezier(0.3, 1, 0.7, 1) 0.3s;
  }
  
  &:checked {
    background-color:${Colors.primary};
  }
  
  &:checked:before {
    left: 3.1rem;
  }

  &:disabled {
    background-color: ${Colors.grayLight};
    cursor: default;
    pointer-events: none;

    &:before {
      color: ${Colors.grayMid};
      text-shadow: none;
    }
  }
`;

export interface ToogleProps {
  id: string;
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  label?: string;
  hint?: string;
}

export const Toggle: FC<ToogleProps> = (props) => {
  const { id, label, hint, value, onChange, disabled = false } = props;
  return (
    <InputWrapper>
      <Label hint={hint} for={id}>{label}</Label>
      <ToggleWrapper>
        <StyledCheckbox
          id={`toggle-${id}`}
          type="checkbox"
          disabled={disabled}
          checked={value}
          onChange={(event) => onChange(event.target.checked)}
        />
      </ToggleWrapper>
    </InputWrapper>
  );
};
